import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _412393d4 = () => interopDefault(import('../src/pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _7b35ee78 = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _1533f86e = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _408c36c6 = () => interopDefault(import('../src/pages/sign_in.vue' /* webpackChunkName: "pages/sign_in" */))
const _21dcdfc8 = () => interopDefault(import('../src/pages/google-calendar/callback.vue' /* webpackChunkName: "pages/google-calendar/callback" */))
const _556b9b90 = () => interopDefault(import('../src/pages/initial-settings/company-profile.vue' /* webpackChunkName: "pages/initial-settings/company-profile" */))
const _05237d24 = () => interopDefault(import('../src/pages/initial-settings/invite-members.vue' /* webpackChunkName: "pages/initial-settings/invite-members" */))
const _5696b000 = () => interopDefault(import('../src/pages/initial-settings/user-profile.vue' /* webpackChunkName: "pages/initial-settings/user-profile" */))
const _e240bca6 = () => interopDefault(import('../src/pages/sessions/callback.vue' /* webpackChunkName: "pages/sessions/callback" */))
const _63461b01 = () => interopDefault(import('../src/pages/sessions/invitation.vue' /* webpackChunkName: "pages/sessions/invitation" */))
const _55ed5f3c = () => interopDefault(import('../src/pages/contents/_uuid/index.vue' /* webpackChunkName: "pages/contents/_uuid/index" */))
const _81869ff8 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds" */))
const _18133095 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds/new.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds/new" */))
const _718a82c4 = () => interopDefault(import('../src/pages/companies/_company_id/customers.vue' /* webpackChunkName: "pages/companies/_company_id/customers" */))
const _75b9a355 = () => interopDefault(import('../src/pages/companies/_company_id/customers/new.vue' /* webpackChunkName: "pages/companies/_company_id/customers/new" */))
const _49dcf49c = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/index" */))
const _382bc14c = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/edit" */))
const _1b175b60 = () => interopDefault(import('../src/pages/companies/_company_id/expiration.vue' /* webpackChunkName: "pages/companies/_company_id/expiration" */))
const _914b1170 = () => interopDefault(import('../src/pages/companies/_company_id/members.vue' /* webpackChunkName: "pages/companies/_company_id/members" */))
const _6e676fd8 = () => interopDefault(import('../src/pages/companies/_company_id/profile.vue' /* webpackChunkName: "pages/companies/_company_id/profile" */))
const _513fd0db = () => interopDefault(import('../src/pages/companies/_company_id/projects.vue' /* webpackChunkName: "pages/companies/_company_id/projects" */))
const _ea35f1c4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/index" */))
const _2c694da2 = () => interopDefault(import('../src/pages/companies/_company_id/projects/calendar.vue' /* webpackChunkName: "pages/companies/_company_id/projects/calendar" */))
const _20eb88b4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/gantt-chart/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/gantt-chart/index" */))
const _42646102 = () => interopDefault(import('../src/pages/companies/_company_id/projects/member-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/member-allocation/index" */))
const _8147e428 = () => interopDefault(import('../src/pages/companies/_company_id/projects/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/new" */))
const _a8b38df4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id" */))
const _6b896309 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/index" */))
const _7b0670c5 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/index" */))
const _2301f9f4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/index" */))
const _d139ce28 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/card/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/card/index" */))
const _c413e4ac = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/detail.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/detail" */))
const _e86b991a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/member.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/member" */))
const _8b96f08e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/index" */))
const _66af6b33 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/index" */))
const _7af43ad9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/summary.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/summary" */))
const _14ae38d3 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-list.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-list" */))
const _25a52bc6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-records.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-records" */))
const _31161b21 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils" */))
const _48ffe270 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils/user-list.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils/user-list" */))
const _0aa3be42 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/new" */))
const _689c7f38 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/posts/index" */))
const _1f47813a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/select-daily-reports.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/select-daily-reports" */))
const _ddf6b4ac = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/fullscreen" */))
const _1a6bace9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/preview" */))
const _52e098de = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/print/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/print/index" */))
const _72efa457 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/index" */))
const _a322f9f4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/fullscreen" */))
const _11e2ae50 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/index" */))
const _025be1f3 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/index" */))
const _786e0118 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/edit" */))
const _538e9680 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index" */))
const _149a920e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/edit" */))
const _7cd573a9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/preview" */))
const _2d31ba73 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/form.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/form" */))
const _2f3ec9e9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/preview" */))
const _e9b84e1e = () => interopDefault(import('../src/pages/companies/_company_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/index" */))
const _5c8748ff = () => interopDefault(import('../src/pages/companies/_company_id/setting.vue' /* webpackChunkName: "pages/companies/_company_id/setting" */))
const _1dc0e14f = () => interopDefault(import('../src/pages/companies/_company_id/sharing-contents/index.vue' /* webpackChunkName: "pages/companies/_company_id/sharing-contents/index" */))
const _56643715 = () => interopDefault(import('../src/pages/companies/_company_id/unavailability.vue' /* webpackChunkName: "pages/companies/_company_id/unavailability" */))
const _1d712b08 = () => interopDefault(import('../src/pages/companies/_company_id/user-profile.vue' /* webpackChunkName: "pages/companies/_company_id/user-profile" */))
const _0429c3d4 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/index" */))
const _acd5d948 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/index" */))
const _71a094f8 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/edit" */))
const _42b2614a = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/preview" */))
const _20bdd2c1 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/ai_pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/ai_pdf" */))
const _7d6d9720 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/edit" */))
const _f4b3c008 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/pdf" */))
const _32ccbe74 = () => interopDefault(import('../src/pages/companies/_company_id/project/_id/schedule/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/project/_id/schedule/pdf" */))
const _0052d088 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/companies",
      component: _412393d4,
      name: "companies"
    }, {
      path: "/logout",
      component: _7b35ee78,
      name: "logout"
    }, {
      path: "/maintenance",
      component: _1533f86e,
      name: "maintenance"
    }, {
      path: "/sign_in",
      component: _408c36c6,
      name: "sign_in"
    }, {
      path: "/google-calendar/callback",
      component: _21dcdfc8,
      name: "google-calendar-callback"
    }, {
      path: "/initial-settings/company-profile",
      component: _556b9b90,
      name: "initial-settings-company-profile"
    }, {
      path: "/initial-settings/invite-members",
      component: _05237d24,
      name: "initial-settings-invite-members"
    }, {
      path: "/initial-settings/user-profile",
      component: _5696b000,
      name: "initial-settings-user-profile"
    }, {
      path: "/sessions/callback",
      component: _e240bca6,
      name: "sessions-callback"
    }, {
      path: "/sessions/invitation",
      component: _63461b01,
      name: "sessions-invitation"
    }, {
      path: "/contents/:uuid?",
      component: _55ed5f3c,
      name: "contents-uuid"
    }, {
      path: "/companies/:company_id/construction-kinds",
      component: _81869ff8,
      name: "companies-company_id-construction-kinds",
      children: [{
        path: "new",
        component: _18133095,
        name: "companies-company_id-construction-kinds-new"
      }]
    }, {
      path: "/companies/:company_id/customers",
      component: _718a82c4,
      name: "companies-company_id-customers",
      children: [{
        path: "new",
        component: _75b9a355,
        name: "companies-company_id-customers-new"
      }, {
        path: ":id",
        component: _49dcf49c,
        name: "companies-company_id-customers-id"
      }, {
        path: ":id/edit",
        component: _382bc14c,
        name: "companies-company_id-customers-id-edit"
      }]
    }, {
      path: "/companies/:company_id/expiration",
      component: _1b175b60,
      name: "companies-company_id-expiration"
    }, {
      path: "/companies/:company_id/members",
      component: _914b1170,
      name: "companies-company_id-members"
    }, {
      path: "/companies/:company_id/profile",
      component: _6e676fd8,
      name: "companies-company_id-profile"
    }, {
      path: "/companies/:company_id/projects",
      component: _513fd0db,
      children: [{
        path: "",
        component: _ea35f1c4,
        name: "companies-company_id-projects"
      }, {
        path: "calendar",
        component: _2c694da2,
        name: "companies-company_id-projects-calendar"
      }, {
        path: "gantt-chart",
        component: _20eb88b4,
        name: "companies-company_id-projects-gantt-chart"
      }, {
        path: "member-allocation",
        component: _42646102,
        name: "companies-company_id-projects-member-allocation"
      }, {
        path: "new",
        component: _8147e428,
        name: "companies-company_id-projects-new"
      }, {
        path: ":id",
        component: _a8b38df4,
        children: [{
          path: "",
          component: _6b896309,
          name: "companies-company_id-projects-id"
        }, {
          path: "attendance",
          component: _7b0670c5,
          name: "companies-company_id-projects-id-attendance"
        }, {
          path: "board_posts",
          component: _2301f9f4,
          name: "companies-company_id-projects-id-board_posts"
        }, {
          path: "card",
          component: _d139ce28,
          name: "companies-company_id-projects-id-card"
        }, {
          path: "detail",
          component: _c413e4ac,
          name: "companies-company_id-projects-id-detail"
        }, {
          path: "member",
          component: _e86b991a,
          name: "companies-company_id-projects-id-member"
        }, {
          path: "reports",
          component: _8b96f08e,
          name: "companies-company_id-projects-id-reports"
        }, {
          path: "schedule",
          component: _66af6b33,
          name: "companies-company_id-projects-id-schedule"
        }, {
          path: "attendance/summary",
          component: _7af43ad9,
          name: "companies-company_id-projects-id-attendance-summary"
        }, {
          path: "attendance/user-list",
          component: _14ae38d3,
          name: "companies-company_id-projects-id-attendance-user-list"
        }, {
          path: "attendance/user-records",
          component: _25a52bc6,
          name: "companies-company_id-projects-id-attendance-user-records"
        }, {
          path: "attendance/utils",
          component: _31161b21,
          name: "companies-company_id-projects-id-attendance-utils",
          children: [{
            path: "user-list",
            component: _48ffe270,
            name: "companies-company_id-projects-id-attendance-utils-user-list"
          }]
        }, {
          path: "board_posts/new",
          component: _0aa3be42,
          name: "companies-company_id-projects-id-board_posts-new"
        }, {
          path: "board_posts/posts",
          component: _689c7f38,
          name: "companies-company_id-projects-id-board_posts-posts"
        }, {
          path: "reports/select-daily-reports",
          component: _1f47813a,
          name: "companies-company_id-projects-id-reports-select-daily-reports"
        }, {
          path: "schedule/fullscreen",
          component: _ddf6b4ac,
          name: "companies-company_id-projects-id-schedule-fullscreen"
        }, {
          path: "schedule/preview",
          component: _1a6bace9,
          name: "companies-company_id-projects-id-schedule-preview"
        }, {
          path: "schedule/print",
          component: _52e098de,
          name: "companies-company_id-projects-id-schedule-print"
        }, {
          path: "schedule/view",
          component: _72efa457,
          name: "companies-company_id-projects-id-schedule-view"
        }, {
          path: "schedule/view/fullscreen",
          component: _a322f9f4,
          name: "companies-company_id-projects-id-schedule-view-fullscreen"
        }, {
          path: "board_posts/:board_id",
          component: _11e2ae50,
          name: "companies-company_id-projects-id-board_posts-board_id"
        }, {
          path: "files/:file_id",
          component: _025be1f3,
          name: "companies-company_id-projects-id-files-file_id"
        }, {
          path: "board_posts/:board_id/edit",
          component: _786e0118,
          name: "companies-company_id-projects-id-board_posts-board_id-edit"
        }, {
          path: "board_posts/:board_id/files",
          component: _538e9680,
          name: "companies-company_id-projects-id-board_posts-board_id-files"
        }, {
          path: "files/:file_id/edit",
          component: _149a920e,
          name: "companies-company_id-projects-id-files-file_id-edit"
        }, {
          path: "files/:file_id/preview",
          component: _7cd573a9,
          name: "companies-company_id-projects-id-files-file_id-preview"
        }, {
          path: "reports/:report_id/form",
          component: _2d31ba73,
          name: "companies-company_id-projects-id-reports-report_id-form"
        }, {
          path: "reports/:report_id/preview",
          component: _2f3ec9e9,
          name: "companies-company_id-projects-id-reports-report_id-preview"
        }]
      }]
    }, {
      path: "/companies/:company_id/reports",
      component: _e9b84e1e,
      name: "companies-company_id-reports"
    }, {
      path: "/companies/:company_id/setting",
      component: _5c8748ff,
      name: "companies-company_id-setting"
    }, {
      path: "/companies/:company_id/sharing-contents",
      component: _1dc0e14f,
      name: "companies-company_id-sharing-contents"
    }, {
      path: "/companies/:company_id/unavailability",
      component: _56643715,
      name: "companies-company_id-unavailability"
    }, {
      path: "/companies/:company_id/user-profile",
      component: _1d712b08,
      name: "companies-company_id-user-profile"
    }, {
      path: "/companies/:company_id/files/:id?",
      component: _0429c3d4,
      name: "companies-company_id-files-id"
    }, {
      path: "/companies/:company_id/reports/:id",
      component: _acd5d948,
      name: "companies-company_id-reports-id"
    }, {
      path: "/companies/:company_id/files/:id?/edit",
      component: _71a094f8,
      name: "companies-company_id-files-id-edit"
    }, {
      path: "/companies/:company_id/files/:id?/preview",
      component: _42b2614a,
      name: "companies-company_id-files-id-preview"
    }, {
      path: "/companies/:company_id/reports/:id/ai_pdf",
      component: _20bdd2c1,
      name: "companies-company_id-reports-id-ai_pdf"
    }, {
      path: "/companies/:company_id/reports/:id/edit",
      component: _7d6d9720,
      name: "companies-company_id-reports-id-edit"
    }, {
      path: "/companies/:company_id/reports/:id/pdf",
      component: _f4b3c008,
      name: "companies-company_id-reports-id-pdf"
    }, {
      path: "/companies/:company_id/project/:id?/schedule/pdf",
      component: _32ccbe74,
      name: "companies-company_id-project-id-schedule-pdf"
    }, {
      path: "/",
      component: _0052d088,
      name: "index"
    }],

    fallback: false
  })
}
